import { render, staticRenderFns } from "./AuthList.vue?vue&type=template&id=6148454a&scoped=true"
import script from "./AuthList.vue?vue&type=script&lang=js"
export * from "./AuthList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6148454a",
  null
  
)

export default component.exports